const MB = 1024 * 1024;

/** Scrollbar fina com track transparente (padrão do Admin). */
export const thinScrollbarSx = {
  scrollbarWidth: "thin" as const,
  scrollbarColor: "rgba(120, 120, 120, 0.35) transparent",
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(120, 120, 120, 0.35)",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(120, 120, 120, 0.5)",
  },
};

export const ACCEPTED_ATTACHMENT_LABEL =
  "PNG, JPG, WEBP, PDF, DOCX, XLSX, XLS, CSV, TSV, TXT, MD, JSON, XML, OFX";

export const ACCEPTED_FILE_INPUT_ACCEPT =
  ".png,.jpg,.jpeg,.webp,.pdf,.docx,.xlsx,.xls,.csv,.tsv,.txt,.md,.json,.xml,.ofx";

/** Mantido em espelho com attachment-validation.helper.ts do backend. */
export const ATTACHMENT_SIZE_LIMITS: Record<string, number> = {
  png: 20 * MB,
  jpg: 20 * MB,
  jpeg: 20 * MB,
  webp: 20 * MB,
  pdf: 20 * MB,
  docx: 10 * MB,
  xlsx: 10 * MB,
  xls: 10 * MB,
  csv: 10 * MB,
  tsv: 10 * MB,
  txt: 10 * MB,
  md: 10 * MB,
  json: 10 * MB,
  xml: 10 * MB,
  ofx: 10 * MB,
};

export const TOTAL_MESSAGE_SIZE_LIMIT = 50 * MB;

function formatMb(bytes: number): string {
  return `${Math.round(bytes / MB)}MB`;
}

export function validateAttachmentFiles(files: File[]): string | null {
  let total = 0;

  for (const file of files) {
    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    const limit = ATTACHMENT_SIZE_LIMITS[extension];

    if (!limit) {
      return `Formato não suportado: "${file.name}". Formatos aceitos: ${ACCEPTED_ATTACHMENT_LABEL}.`;
    }

    if (file.size > limit) {
      return `O arquivo "${file.name}" excede o limite de ${formatMb(
        limit,
      )} para este formato.`;
    }

    total += file.size;
  }

  if (total > TOTAL_MESSAGE_SIZE_LIMIT) {
    return `O total de anexos excede o limite de ${formatMb(
      TOTAL_MESSAGE_SIZE_LIMIT,
    )} por mensagem.`;
  }

  return null;
}
